import {type TerminalNode, createDefaultValidator} from '../flow'

export const FINAL_PRODUCT_ID = 'final-product'

export const CRUSHER_FLOW_CONFIG_NAME = 'crusherFlowConfig'

export const MAX_CRUSHER_FLOW_SETUPS = 5

export const MAX_CRUSHER_CHAIN_DEPTH = 3

export const CRUSHER_TERMINAL_NODE: TerminalNode = {
  id: FINAL_PRODUCT_ID,
  label: 'Final Product'
}

export const crusherValidator = createDefaultValidator({
  terminalNodeId: FINAL_PRODUCT_ID,
  maxChainDepth: MAX_CRUSHER_CHAIN_DEPTH
})
